import React from "react";

type ArrowIconProps = {
  width?: number;
  height?: number;
}

const ArrowIcon: React.FC<ArrowIconProps> = ({width = 12, height = 12}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 1H12M12 1V13M12 1L0.5 12"></path>
    </svg>
  );
};

export default ArrowIcon;
